import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { ModalConfirm } from 'mailup-web-components'
import { useAtom } from 'jotai'
import { modalDeleteCategoryState } from '../state/state'
import { useAtomCallback } from 'jotai/utils'
import {
  closeModalDeleteCategoryCallback,
  submitModalDeleteCategoryCallback,
} from '../callbacks/modal'

const ModalDeleteCategory: FC = () => {
  const intl = useIntl()

  const [{ show }] = useAtom(modalDeleteCategoryState)
  const handleConfirm = useAtomCallback(submitModalDeleteCategoryCallback)
  const handleCancel = useAtomCallback(closeModalDeleteCategoryCallback)

  return (
    <ModalConfirm
      show={show}
      variant='delete'
      onClickConfirm={handleConfirm}
      onClickCancel={handleCancel}
      showClose
      closeOnOverlayClick
      data-mu-test='modal-delete-category'
      title={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Title',
      })}
      message={intl.formatMessage({
        id: 'Load.ModalConfermeDelete.Description',
      })}
      stringConfirm={intl.formatMessage({
        id: 'Load.MailupCommon.Confirm',
      })}
      stringCancel={intl.formatMessage({
        id: 'Load.MailupCommon.Cancel',
      })}
    />
  )
}

export default ModalDeleteCategory
